// extracted by mini-css-extract-plugin
export default {"quillWrapper":"quillWrapper__-44fd5448","label":"label__-44fd5448","disabled":"disabled__-44fd5448"};